import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialCard } from './TestimonialCard';
export function OpeningTestimonials() {
  const testimonials = [{
    quote: 'Organicé toda mi planificación anual en un fin de semana. Ahora tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico antes de la semana.',
    name: 'Sofía M.',
    location: 'Buenos Aires',
    role: 'Entrenadora de Tenis en Club'
  }, {
    quote: 'Las progresiones técnicas por nivel cambiaron todo. Mis alumnos mejoraron más en 2 meses que en todo el año anterior. Y dejaron de irse.',
    name: 'Carolina R.',
    location: 'Rosario',
    role: 'Entrenadora de Tenis en Academia'
  }, {
    quote: 'Adapto la misma clase a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo.',
    name: 'Valentina F.',
    location: 'Córdoba',
    role: 'Entrenadora de Tenis Grupal e Individual'
  }];
  return <section className="py-10 md:py-16 bg-cream bg-court-pattern-dark" data-id="element-184">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-185">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-186">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} data-id="element-187">
              <TestimonialCard {...t} data-id="element-188" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}